import { render, staticRenderFns } from "./filter-text.vue?vue&type=template&id=0b736cca&"
import script from "./filter-text.vue?vue&type=script&lang=js&"
export * from "./filter-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b736cca')) {
      api.createRecord('0b736cca', component.options)
    } else {
      api.reload('0b736cca', component.options)
    }
    module.hot.accept("./filter-text.vue?vue&type=template&id=0b736cca&", function () {
      api.rerender('0b736cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/filter-components/filter-text.vue"
export default component.exports